import styled from "@emotion/styled";

export const SearchWrap = styled.div`
  position: relative;
  display: inline-flex;
  align-items: center;
  width: 100%;
  max-width: 420px;

  input[type="search"]::-webkit-search-cancel-button {
    -webkit-appearance: none;
  }
`;

export const ClearBtn = styled.button`
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
  width: 24px;
  height: 24px;
  border: 0;
  background: transparent;
  cursor: pointer;
  font-size: 18px;
  line-height: 1;
  color: ${({ theme }) => theme.palette.text.primary};
  opacity: 0.8;
  border-radius: 50%;

  &:hover {
    opacity: 0.9;
  }

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.palette.primary.main};
  }
`;


